import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg text-white text-lg font-bold">
                🍉
              </span>
              <span className="text-xl font-bold text-background-50" style={{ fontFamily: "var(--font-heading)" }}>
                吃瓜<span className="text-primary-400">51</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              吃瓜51 — 专注于热门娱乐爆料、明星八卦、社会热点的吃瓜聚合平台。第一时间汇聚最新瓜料，让你随时随地吃瓜不断线。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm text-background-400 hover:text-background-100 transition-colors">首页</Link>
              <Link to="/category/yule-bagua" className="block text-sm text-background-400 hover:text-background-100 transition-colors">娱乐八卦</Link>
              <Link to="/category/shehui-redian" className="block text-sm text-background-400 hover:text-background-100 transition-colors">社会热点</Link>
              <Link to="/category/dujia-baoliao" className="block text-sm text-background-400 hover:text-background-100 transition-colors">独家爆料</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">关于我们</h4>
            <div className="space-y-2.5">
              <Link to="/about" className="block text-sm text-background-400 hover:text-background-100 transition-colors">品牌介绍</Link>
              <Link to="/about" className="block text-sm text-background-400 hover:text-background-100 transition-colors">用户口碑</Link>
              <Link to="/about" className="block text-sm text-background-400 hover:text-background-100 transition-colors">联系我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">联系方式</h4>
            <div className="space-y-2.5 text-sm text-background-400">
              <p>邮箱：contact@chigua51.com</p>
              <p>合作：bd@chigua51.com</p>
              <p>工作时间：周一至周五 9:00-18:00</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 吃瓜51 — 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors text-xs" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors text-xs" rel="nofollow">用户协议</a>
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors text-xs" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}